import Feature from '@/common/Feature';
import { Middle } from '@/components/Align';
import useDocumentTitle from '@/hooks/useDocumentTitle';

const TITLE = 'Schedule Automation Report';

const ScheduleAutomationReport = () => {
  useDocumentTitle(TITLE);

  return (
    <Feature name={TITLE} restricted>
      <Middle.Center>
        <h1>Coming soon...</h1>
      </Middle.Center>
    </Feature>
  );
};

export default ScheduleAutomationReport;
